<template>
  <div>
    <div class="app-reg-notice">
      <div v-if="stepNum == 1 || stepNum == 2 || stepNum == 3">
        <strong>Duplicate Registration -</strong>
        <span class="vehicle-type">{{ year }} {{ make }} {{ model !='UNKNOWN' ? model : '' }} {{ plateNumber }} / {{ plateType }}</span>
      </div>
      <div v-if="stepNum == 4">
        <strong>Transaction Cart</strong>
      </div>
      <div v-if="stepNum == 5">
        <strong>{{ (store.state.guestLogin.totalBill && store.state.guestLogin.totalBill.totalSumFeeAmount > 0) ? 'Payment information' : 'Contact information' }}</strong>
      </div>
      <div v-if="stepNum == 6">
        <strong>Transaction confirmation</strong>
      </div>
    </div>
    <div>
      <SystemAlert/>
    </div>
    <Stepper :step="stepNum" />
    <GetReady v-if="stepNum == 1" @getStep="getStep" />
    <TransactionInfo v-if="stepNum == 2" @getStep="getStep" />
    <TransactionFee v-if="stepNum == 3" @getStep="getStep" />
    <TransactionCart v-if="stepNum == 4" @getStep="getStep" />
    <Payment v-if="stepNum == 5" @getStep="getStep" />
    <Confirmation v-if="stepNum == 6" @getStep="getStep" />
  </div>
</template>


<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import appConfig from '@/app.config';
import Stepper from '../../components/Stepper.vue';
import GetReady from './GetReady.vue';
import TransactionInfo from './TransactionInfo.vue';
import TransactionFee from './TransactionFee.vue';
import TransactionCart from '../renewReg/TransactionCart.vue';
import Payment from '../renewReg/Payment.vue';
import Confirmation from '../renewReg/Confirmation.vue';
import SystemAlert from '@/components/SystemAlert';
import { useHead } from '@unhead/vue'

useHead({
  title: `Duplicate Registration | ${appConfig.shortName}`,
  meta: [
    {
      name: 'description',
      content: appConfig.description
    }
  ]
});

// Vuex Store
const store = useStore();

// Reactive data ref 
const year = ref(store.state.guestLogin.selectRenewRegistartion.year);
const make = ref(store.state.guestLogin.selectRenewRegistartion.make);
const model = ref(store.state.guestLogin.selectRenewRegistartion.model);
const plateNumber = ref(store.state.guestLogin.selectRenewRegistartion.plateNumber);
const plateType = ref(store.state.guestLogin.selectRenewRegistartion.plateType);

// Computed Properties
const stepNum = computed(() => store.state.guestLogin.step);

// Methods
const getStep = (val) => {
  console.log(val);
};

const handlePopstate = () => {
  window.history.go(1);
};

// Lifecycle Hooks
onMounted(() => {
  window.history.replaceState(history.state, '', window.location.href);
  window.addEventListener('popstate', handlePopstate);
});

onUnmounted(() => {
  window.removeEventListener('popstate', handlePopstate);
});
</script>


<style scoped lang="scss">
  .app-reg-notice {
    max-width: 100%;
    background: var(--ri-light-blue);
    height: 100%;
    display: flex;
    padding: 1em;
    font-size: 20px;
    margin-bottom: 0px;
    margin-top: 5px;
    padding-left: var(--padding-horizontal);
    padding-right: var(--padding-horizontal);

    @media print {
      @page { size: 11in 8.5in; }
      background-color: var(--print-background);
    }
    .vehicle-type {
      margin-left: 5px;
    }
  }
  @media only screen and (max-width: 796px) {
    .app-reg-notice {
      display: block; 
      margin-top: 5px;
    }
  }
</style>
